import { Component, OnInit, AfterContentInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { HelperService } from 'app/services';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent implements OnInit, OnChanges, AfterContentInit {
  @Input() value: string = '';
  @Input() placeholder: string = '';
  @Input() label: string = this.placeholder;
  @Input() name: string = '';
  @Input() id: string = '';
  @Input() validationId: string = '';
  @Input() type: string = 'text'; // [text, number]
  @Input() errorMessage: string = '';
  @Input() isInvalid: boolean = false;
  @Input() disabled: boolean = false;
  @Input() prohibited: boolean = false;
  @Input() floatingLabel: boolean = false;
  @Input() styleClass: string = '';
  @Input() styleClassInput: string = '';
  @Input() styleClassLabel: string = '';
  @Input() labelFontSize: string = '';
  @Input() maxLength: number = 500;
  @Input() thousandSeparator: string = '';
  @Input() prefix: string = '';
  @Input() suffix: string = '';
  @Input() theme: string = 'primary'; // [light, primary, secondary, border]
  @Input() hasHoverEffect: boolean = false;
  @Input() hasBgOnActive: boolean = false;
  @Input() hasHoverBorderBottom: boolean = true;
  @Input() hasBorderBottomOnActive: boolean = true;
  @Input() hasActions: boolean = false;
  @Input() autoFocus: boolean = false;
  @Input() dropSpecialCharacters: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() selectTextOnFocus: boolean = false;
  @Input() fontSize: number = 14;
  @Input() fontFamily: boolean = false;
  @Input() leftIcon: string = '';
  @Input() rightIcon: string = '';
  @Input() cancelIcon: string = 'fal fa-times';
  @Input() saveIcon: string = 'fal fa-check';
  @Input() mask: string = '';
  @Input() isPasswordHidden: boolean = true;
  @Input() hasShowPasswordIcon: boolean = false;
  @Input() rows: number = 1;
  @Input() textAreaId: string = '';
  @Input() autoGrow: boolean = false;
  @Input() maxAutoGrowHeight: number = 22;
  @Input() textAreaHeight: string = '';
  @Input() setAbsoluteHeight: string = '';
  @Input() errorClass: string = '';
  @Input() errorIcon: string = '';
  @Input() warningMessage: string = '';

  @Output() appFocus = new EventEmitter<any>();
  @Output() appBlur = new EventEmitter<any>();
  @Output() appChange = new EventEmitter<any>();
  @Output() appClickOutside = new EventEmitter<any>();
  @Output() appCancel = new EventEmitter<any>();
  @Output() appSave = new EventEmitter<any>();
  @Output() appKeyUp = new EventEmitter<any>();
  @Output() appEnter = new EventEmitter<any>();
  @Output() appTabPress = new EventEmitter<any>();
  @Output() appClear = new EventEmitter<any>();
  @Output() appClick = new EventEmitter<any>();
  @Output() appRightIconClick = new EventEmitter<any>();

  @ViewChild('textareaControl', { static: true }) textareaControl: ElementRef;
  @ViewChild('textareaContainer', { static: true })
  textareaContainer: ElementRef;

  setActiveTimeOut: any;
  isActive: boolean = false;
  clickOutsideListener: any;
  text: string = '';

  constructor(private helperService: HelperService) {}

  ngOnInit() {
    this.setStartUpValue();

    if (this.autoGrow) {
      setTimeout(() => {
        try {
          if (this.setAbsoluteHeight) {
            $(`#V${this.textAreaId}`).css('height', `${this.setAbsoluteHeight}`);
          } else {
            const height = this.textareaControl.nativeElement.scrollHeight;
  
            if (height && height < this.maxAutoGrowHeight) {
              $(`#V${this.textAreaId}`).css('height', `${height}px`);
            } else if (height) {
              $(`#V${this.textAreaId}`).css('height', `${this.maxAutoGrowHeight}px`);
            }
  
            $(`#V${this.textAreaId}`).on('input', this.setTextAreaHeight);
          }
        } catch (err) {}
      }, 1000);
    }
  }

  ngOnChanges(change: any) {
    const { autoFocus, value } = change;
    if (autoFocus) {
      if (!autoFocus.previousValue && autoFocus.currentValue) {
        if (this.textareaControl.nativeElement) {
          this.setActiveTimeOut = setTimeout(() => {
            this.textareaControl.nativeElement.focus();
          }, 5);
        }
      }
    }

    if (value && this.autoGrow) {
      if ((!value.previousValue && value.currentValue) || value.previousValue !== value.currentValue) {
        setTimeout(() => {
          if (this.setAbsoluteHeight) {
            $(`#V${this.textAreaId}`).css('height', `${this.setAbsoluteHeight}`);
          } else {
            const height = this.textareaControl.nativeElement.scrollHeight;
  
            if (height && height < this.maxAutoGrowHeight) {
              $(`#V${this.textAreaId}`).css('height', `${height}px`);
            } else if (height) {
              $(`#V${this.textAreaId}`).css('height', `${this.maxAutoGrowHeight}px`);
            }
          }
        }, 400);
      }
    }
  }

  ngAfterContentInit() {
    if (this.autoFocus) {
      this.textareaControl.nativeElement.focus();
    }
  }

  setTextAreaHeight = (event: any) => {
    const self = event.target;

    if (self.scrollHeight > 25) {
      self.style.height = 'auto';
      self.style.height = self.scrollHeight + 'px';
      self.style.maxHeight = this.maxAutoGrowHeight + 'px';
    }
  };

  setStartUpValue() {
    if (this.thousandSeparator === ',') {
      this.mask = 'separator.2';
    }

    if (this.type === 'password') {
      this.hasShowPasswordIcon = true;
    }
  }

  addOutsideClickListener() {
    this.clickOutsideListener = this.helperService.documentClickedTarget.subscribe((target) => {
      if (this.textareaContainer.nativeElement.contains(target)) {
      } else {
        this.isActive = false;
        this.appClickOutside.emit(this.value);
        this.removeOutsideClickListener();
      }
    });
  }

  removeOutsideClickListener() {
    if (this.clickOutsideListener) {
      this.clickOutsideListener.unsubscribe();
    }
  }

  onFocus() {
    if (this.disabled || this.prohibited) {
      return;
    }
    this.isActive = true;
    this.textareaControl.nativeElement.focus();

    if (this.selectTextOnFocus) {
      this.textareaControl.nativeElement.select();
    }

    this.appFocus.emit();
    this.addOutsideClickListener();
  }

  onBlur() {
    this.isActive = false;
    this.appBlur.emit(this.value);
    this.removeOutsideClickListener();
    if (this.setActiveTimeOut) {
      clearInterval(this.setActiveTimeOut);
    }
  }

  onClick() {
    this.appClick.emit();
  }

  onModalChange(value) {
    this.appChange.emit(value);
    if (!value) {
      this.appClear.emit(value);
    }
  }

  onCancel() {
    this.appCancel.emit(this.value);
  }

  onSave() {
    this.appSave.emit(this.value);
  }

  onKeyUp(event) {
    this.appKeyUp.emit(this.value);
  }

  onEnter() {
    this.appEnter.emit(this.value);
  }

  onTabPress() {
    this.appTabPress.emit();
  }

  toggleHidePassword() {
    this.isPasswordHidden = !this.isPasswordHidden;
    this.type = this.isPasswordHidden ? 'password' : 'text';
  }

  handleRightIconClick() {
    this.appRightIconClick.emit(true);
  }
}
